<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="Bayaran Bantuan - Senarai">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt2">
                    <div class="xs6 mr5">
                        <w-input v-model="cari.no_rujukan"
                            >No. Rujukan Subsidiari</w-input
                        >
                    </div>
                    <div class="xs6 mr5">
                        <z-lookup
                            label="Skim Bantuan"
                            :url="
                                service_utiliti +
                                'lookup/lkp_tuntutan_bantuan_skim'
                            "
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_tuntutan_bantuan_skim_id"
                        />
                    </div>
                </w-flex>
                <w-flex class="mt2">
                    <div class="xs6 mr5">
                        <w-input v-model="cari.nama_id">No. Id/Nama</w-input>
                    </div>

                    <div class="xs6 mr5">
                        <z-lookup
                            label="Status"
                            name="status"
                            :url="
                                service_utiliti +
                                'lookup/lkp_tuntutan_bantuan_status'
                            "
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_tuntutan_bantuan_status_id"
                        />
                    </div>
                </w-flex>
                <w-flex class="mt2">
                    <div class="xs6 mr5">
                        <z-lookup
                            label="Perihal Tunggakan"
                            name="perihal"
                            :url="
                                service_utiliti +
                                'lookup/lkp_tuntutan_bantuan_perihal'
                            "
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_tuntutan_bantuan_perihal_id"
                        />
                    </div>
                    <div class="xs6 mr5"></div>
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>

                    <w-button
                        class="ml1"
                        @click="$refs.dform.validate()"
                        :loading="cari.loading"
                    >
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>
            <br />
            <center v-if="cari.loading">
                <w-progress class="ma1" circle></w-progress>
            </center>
            <z-table
                ref="tbluser"
                title="Paparan Rekod"
                :headers="table.headers"
                :items="table.items"
                :meta="table.meta"
                class=""
            >
                <template #header-label="{ header, label, index }">
                    <template v-if="header.key == 'action'">
                        Tindakan
                    </template>
                </template>
                <template #item-cell.action="{ item, label, header, index }">
                    <w-flex class="flex justify-center">
                        <inertia-link :href="$route('bantuan.show', item.id)">
                            <w-tooltip top>
                                <template #activator="{ on }">
                                    <w-icon v-on="on"> fal fa-file </w-icon>
                                </template>
                                Papar
                            </w-tooltip>
                        </inertia-link>
                    </w-flex>
                </template>
            </z-table>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
// import ZenOne from '@/Shared/ZenOne'
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_tunggakan + "tuntutan_bantuan",
            reload: true,
            form_profil: {},
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/ihasil" },
                { label: "Bantuan Am", route: "/tuntutan_bantuan" },
                { label: "Senarai ", route: "/tuntutan_bantuan" },
            ],
            cari: {
                no_rujukan: "",
                nama_id: "",
                profil_id: "",
                lkp_tuntutan_bantuan_skim_id: "",
                lkp_tuntutan_bantuan_perihal_id: "",
                lkp_tuntutan_bantuan_status_id: "",
            },
        };
    },
    methods: {
        search() {
            this.cari.loading = true;
            this.$inertia.visit(
                window.route("bantuan.index") +
                    "?no_rujukan=" +
                    this.cari.no_rujukan +
                    "&nama_id=" +
                    this.cari.nama_id +
                    "&lkp_tuntutan_bantuan_skim_id=" +
                    this.cari.lkp_tuntutan_bantuan_skim_id +
                    "&lkp_tuntutan_bantuan_perihal_id=" +
                    this.cari.lkp_tuntutan_bantuan_perihal_id,
                +"&lkp_tuntutan_bantuan_status_id=" +
                    this.cari.lkp_tuntutan_bantuan_status_id,
                { preserveScroll: true }
            );
        },

        reset() {
            this.cari = {
                no_rujukan: "",
                nama_id: "",
                lkp_tuntutan_bantuan_skim_id: "",
                lkp_tuntutan_bantuan_perihal_id: "",
                lkp_tuntutan_bantuan_status_id: "",
            };
            this.search();
        },
    },
    watch: {},
    mounted() {
        // override default setting
        // this.getData();
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.no_rujukan == "undefined") {
            this.cari.no_rujukan = "";
        }
        if (this.cari.profil_id == "undefined") {
            this.cari.profil_id = "";
        }
        if (this.cari.lkp_tuntutan_bantuan_skim_id == "undefined") {
            this.cari.lkp_tuntutan_bantuan_skim_id = "";
        }
        if (this.cari.lkp_tuntutan_bantuan_perihal_id == "undefined") {
            this.cari.lkp_tuntutan_bantuan_perihal_id = "";
        }
        if (this.cari.nama_id == "undefined") {
            this.cari.nama_id = "";
        }
        if (this.cari.lkp_tuntutan_bantuan_status_id == "undefined") {
            this.cari.lkp_tuntutan_bantuan_status_id = "";
        }
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
